import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSettings, track } from "@/lib/api";

const inject = (id, src, inline) => {
  if (document.getElementById(id)) return;
  const s = document.createElement("script"); s.id = id;
  if (src) { s.src = src; s.async = true; } else s.innerHTML = inline;
  document.head.appendChild(s);
};

export const Analytics = () => {
  const { data: s } = useSettings();
  const { pathname } = useLocation();
  const a = s?.analytics;
  useEffect(() => {
    if (!a) return;
    if (a.gtm_id) inject("gtm", null, `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${a.gtm_id}');`);
    if (a.ga4_id) { inject("ga4-src", `https://www.googletagmanager.com/gtag/js?id=${a.ga4_id}`); inject("ga4", null, `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${a.ga4_id}',{anonymize_ip:true});`); }
    if (a.meta_pixel_id) inject("fbq", null, `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${a.meta_pixel_id}');`);
    if (a.search_console_verification && !document.querySelector('meta[name="google-site-verification"]')) { const m = document.createElement("meta"); m.name = "google-site-verification"; m.content = a.search_console_verification; document.head.appendChild(m); }
  }, [a]);
  useEffect(() => { track(pathname.startsWith("/programs/") ? "course_page_view" : "page_view"); }, [pathname]);
  return null;
};
